import { render, staticRenderFns } from "./CheckAirFreightModal.vue?vue&type=template&id=7d8a79b2&scoped=true&"
import script from "./CheckAirFreightModal.vue?vue&type=script&lang=js&"
export * from "./CheckAirFreightModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8a79b2",
  null
  
)

export default component.exports